module.exports = __webpack_public_path__ + "img/media (20).1a1218d6.png";